export default "<p>loader-store works!</p>\r\n";